import React, { createContext, useContext, useState, useEffect } from "react";
import { ApiRequest, ApiRequestNoLoder } from "../../services/api";
import { PostLoginContext } from "../apis/post";
interface AuthContextType {
  isAuthenticated: boolean;
  role: string | null;
  login: (username: string, password: string) => Promise<any>;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
    return localStorage.getItem("token") !== null; // Check for auth token
  });
  
  const [role, setRole] = useState<string | null>(() => {
    const data = localStorage.getItem("data");
    if (data) {
      try {
        const parsed = JSON.parse(data);
        return parsed.Role || null;
      } catch {
        return null;
      }
    }
    return null;
  });

  const login = async (username: string, password: string) => {
    const loginData = {
      identifier: username,
      password: password,
    };

    const response: any = await PostLoginContext(loginData)
    
    if (!response){
      console.log("LoginResponse", response);
      return response;
    }

    const { data, message, status } = response;
    if (status == "success") {
      // Store the actual JWT token from the response
      const accessToken = data.access_token;
      const userRole = data.Role; // Get role from response
      
      if (accessToken) {
        localStorage.setItem("token", accessToken); // Store the actual JWT token
        localStorage.setItem("data", JSON.stringify(data));
        setIsAuthenticated(true);
        setRole(userRole); // Set role in state
      } else {
        console.error("No access_token in login response");
        return { status: "error", message: "No access token received" };
      }
    }
    return response
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("data");
    setIsAuthenticated(false);
    setRole(null);
  };

  useEffect(() => {
    setIsAuthenticated(localStorage.getItem("token") !== null);
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, role, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
